//
// Fancybox
//
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

export default function ({ el }) {
    Fancybox.bind()
}
